module.exports = __webpack_public_path__ + "static/media/green-check-mark.23c4a664.svg";